import { ProductState } from "../../types";
import {
    FETCH_ALL_PRODUCTS_SUCCESS,
    FETCH_ALL_PRODUCTS_REQUEST,
    LOGOUT_USER_REQUEST
} from "../constants";

const initialState: ProductState = {
  products: [],
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_ALL_PRODUCTS_REQUEST:
        return {
            ...state,
            products: action.payload.allProducts,
        };
    case FETCH_ALL_PRODUCTS_SUCCESS:
        return {
            ...state,
            products: action.payload.allProducts,
        };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
